import { Grid, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
// import Cards from "./ Cards";
import ClickStatsChart from "./ClickStatsChart";
import { useDispatch, useSelector } from "react-redux";
import { getAffDashboard } from "../../../store/reducers/affiliateReducer";
import AffiliateTable from "./AffiliateTable";
import CreateAffililiate from "../CreateAffililiate";
import VisitorChart from "./VisitorChart";
import backIcon from "../../../assets/icons/leftarrow.svg";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Cards from "./Cards";

const { RangePicker } = DatePicker; // Use RangePicker for date range selection

const AffDashboard = () => {
  const dispatch = useDispatch();
  const dashboard = useSelector((state) => state.affiliate.dashboard);
  const [showAffiliateCode, setShowAffiliateCode] = useState(false);
  const [params, setParams] = useState({
    // start_date: dayjs().subtract(7, "days").format("DD/MMM/YYYY"),
    // end_date: dayjs().format("DD/MMM/YYYY"),
    start_date: null,
    end_date: null,
  });

  useEffect(() => {
    dispatch(getAffDashboard(params));
  }, [params, dispatch]);

  const handleShowAffiliate = () => {
    setShowAffiliateCode(!showAffiliateCode);
  };

  const handleBackButtonClick = () => {
    setShowAffiliateCode(false);
  };

  const [paramsValue, setParamsValue] = useState({
    page: 1,
    page_size: 15,
  });
  const handleDateRangeChange = (dates) => {
    if (!dates || !dates[0] || !dates[1]) return;

    setParams({
      start_date: dates[0].format("DD/MMM/YYYY"),
      end_date: dates[1].format("DD/MMM/YYYY"),
    });
  };

  return (
    <>
      {showAffiliateCode ? (
        <div>
          <span
            className="back_btn"
            onClick={handleBackButtonClick}
            style={{ cursor: "pointer", width: "fit-content" }}
          >
            <img src={backIcon} alt="Back" />
            Back
          </span>
          <CreateAffililiate />
        </div>
      ) : (
        <>
          {/* <div className="affiliate_datepicker_container">
            <div className="date_selector">
              <RangePicker
                // defaultValue={[
                //   dayjs(params.start_date),
                //   dayjs(params.end_date),
                // ]}
                format="YYYY-MM-DD"
                onChange={handleDateRangeChange}
                allowClear
              />
            </div>
          </div> */}
          <Grid className="mainContainer_Chart">
            <Grid container item xl={12}>
              <Cards data={dashboard} />
            </Grid>
            <div className="charts_wrapper">
              <Grid xs={12} style={{ width: "100%" }}>
                <ClickStatsChart
                  data={dashboard?.click_stats}
                  params={params}
                  setParams={setParams}
                />
              </Grid>
            </div>
            <Grid container item xs={12}>
              <AffiliateTable
                paramsValue={paramsValue}
                setParamsValue={setParamsValue}
                handleShowAffiliate={handleShowAffiliate}
                showAffiliateCode={showAffiliateCode}
                setShowAffiliateCode={setShowAffiliateCode}
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default AffDashboard;
